import { createFileRoute } from "@tanstack/react-router";
import { InvestorShell } from "@/components/investor/InvestorShell";
import { ExecutiveOverview } from "@/components/investor/sections/ExecutiveOverview";
import { GovernanceValidation } from "@/components/investor/sections/GovernanceValidation";
import { DecisionIntelligence } from "@/components/investor/sections/DecisionIntelligence";
import { OutcomeAttribution } from "@/components/investor/sections/OutcomeAttribution";
import { PerformanceIntelligence } from "@/components/investor/sections/PerformanceIntelligence";

export const Route = createFileRoute("/investor-preview")({
  head: () => ({
    meta: [
      { title: "Orion Investor Portal (Internal Preview)" },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content:
          "Internal preview of the Orion investor portal. Dummy data only. Not for distribution.",
      },
    ],
  }),
  component: InvestorPreviewPage,
});

function InvestorPreviewPage() {
  // Narrative order: Trust (Overview) -> Proof (Governance) -> Edge thesis
  // (Decision) -> Proof of edge (Attribution) -> Result (Performance).
  return (
    <InvestorShell>
      <ExecutiveOverview />
      <GovernanceValidation />
      <DecisionIntelligence />
      <OutcomeAttribution />
      <PerformanceIntelligence />
    </InvestorShell>
  );
}
